// extracted by mini-css-extract-plugin
export default {"title":"Header_title__3cB1Z","subTitleBlock":"Header_subTitleBlock__lGDoN","subTitle":"Header_subTitle__9C9Xh","images":"Header_images__Fw3nn"};